import { type MutableRefObject } from 'react';

import { Select, Text, Textarea, type TypeSelectOption } from '@thefarmersfront/kitchen';

import { FormField, ModalSection, NumberUnitInput } from '~/components/common';

import { DEFAULT_INPUT_STATUS } from '~/constants';
import { CLAIM_TOTAL_BOX_OPTIONS } from '~/constants/claim';

import type { TypeReturnRegisterSecondStepValues, TypeReturnRegisterSecondStepValuesState } from '~/types/claim.types';

import styles from '../ClaimReturnRegisterSecondStepContent.module.scss';

const ClaimReturnRegisterSecondStepDefaultInfo = ({
  data,
  dataState,
  onChange,
  onChangeState,
  errorFieldRefs,
}: {
  data: TypeReturnRegisterSecondStepValues;
  dataState: TypeReturnRegisterSecondStepValuesState;
  onChange: (values: Partial<TypeReturnRegisterSecondStepValues>) => void;
  onChangeState: (values: Partial<TypeReturnRegisterSecondStepValuesState>) => void;
  errorFieldRefs: MutableRefObject<Record<string, HTMLElement | null>>;
}) => {
  return (
    <ModalSection className={styles['default-info']} title="기본 정보">
      <FormField
        label="출고요청번호"
        required
        contentAlign="center"
        contents={<Text size="large">{data.outboundCode}</Text>}
      />
      <FormField
        label="원출고센터"
        required
        contentAlign="center"
        contents={<Text size="large">{data.outboundClusterCenter}</Text>}
      />
      <FormField
        label="원배송사"
        required
        contentAlign="center"
        contents={<Text size="large">{data.outboundCourier}</Text>}
      />
      <FormField
        label="회수배송사"
        required
        contentAlign="center"
        contents={<Text size="large">{data.returnCourier}</Text>}
      />
      <FormField
        label="배송사 전달사항"
        contents={
          <Textarea
            placeholder="입력"
            size="small"
            count
            maxLength={30}
            value={data.courierMemo}
            onChange={(e) => onChange({ courierMemo: e.target.value })}
            onBlur={(e) => onChange({ courierMemo: e.target.value.trim() })}
          />
        }
      />
      <FormField
        label="박스 총 수량"
        required
        tooltip={{
          maxWidth: '263px',
          description: '고객이 회수 요청한 박스의 총 수량입니다.\n부정확할 경우 택배사가 회수를 실패할 수 있습니다.',
        }}
        contents={
          <>
            <Select
              ref={(el) => (errorFieldRefs.current.totalBox = el)}
              placeholder="선택"
              size="small"
              maxWidth="148px"
              options={CLAIM_TOTAL_BOX_OPTIONS}
              status={dataState.totalBox.status}
              validationMessage={dataState.totalBox.message}
              value={data.totalBox}
              onChange={(_: unknown, value: TypeSelectOption) => {
                if (value?.value === data.totalBox?.value) return;
                onChange({ totalBox: value, totalBoxInput: '' });
              }}
              onClick={() => onChangeState({ totalBox: DEFAULT_INPUT_STATUS, totalBoxInput: DEFAULT_INPUT_STATUS })}
            />
            {data.totalBox?.value === 'ETC' && (
              <NumberUnitInput
                ref={(el) => (errorFieldRefs.current.totalBoxInput = el)}
                placeholder="숫자만 입력"
                size="small"
                maxWidth="133px"
                unit="개"
                status={dataState.totalBoxInput.status}
                validationMessage={dataState.totalBoxInput.message}
                value={data.totalBoxInput}
                onChange={(e) => {
                  onChange({ totalBoxInput: e.target.value });
                  onChangeState({ totalBoxInput: DEFAULT_INPUT_STATUS });
                }}
                onBlur={(e) => onChange({ totalBoxInput: e.target.value.trim() })}
                onClick={() => onChangeState({ totalBoxInput: DEFAULT_INPUT_STATUS })}
              />
            )}
          </>
        }
        contentsClassName={styles['box-quantity-container']}
      />
    </ModalSection>
  );
};

export default ClaimReturnRegisterSecondStepDefaultInfo;
